import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../service/Api";

export const getMedallionDetails = createAsyncThunk(
  "profile/getMedallionDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Api.get(`/medallion/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to get medallion details" }
      );
    }
  }
);

export const uploadFile = createAsyncThunk(
  "profile/uploadFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await Api.post("/file_upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to upload file" }
      );
    }
  }
);

export const updateMedallion = createAsyncThunk(
  "profile/updateMedallion",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Api.put(`/update_medallion/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to update medallion" }
      );
    }
  }
);

export const createTribute = createAsyncThunk(
  "profile/createTribute",
  async ({ medallionId, data }, { rejectWithValue }) => {
    try {
      const response = await Api.post(`/create-tribute/${medallionId}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to create tribute" }
      );
    }
  }
);

export const listGifts = createAsyncThunk(
  "profile/listGifts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Api.get("/gifts_listing");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch gifts" }
      );
    }
  }
);

export const purchaseGift = createAsyncThunk(
  "profile/purchaseGift",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Api.post("/purchase_gift_secret", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to purchase gift" }
      );
    }
  }
);

export const verifyGiftTribute = createAsyncThunk(
  "profile/verifyGiftTribute",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Api.post("/verify_gitftribute", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to verify gift tribute" }
      );
    }
  }
);

export const addTribute = createAsyncThunk(
  "profile/addTribute",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Api.post("/add_tributes", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to add tribute" }
      );
    }
  }
);

export const getTributes = createAsyncThunk(
  "profile/getTributes",
  async (medallionId, { rejectWithValue }) => {
    try {
      const response = await Api.get(`/tribute_list/${medallionId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch tributes" }
      );
    }
  }
);

export const addNewsletter = createAsyncThunk(
  "profile/addNewsletter",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Api.post("/add_newsletter", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to subscribe to newsletter" }
      );
    }
  }
);

export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Api.get("/get_profile");
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch profile" }
      );
    }
  }
);

export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Api.put("/update_profile", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to update profile" }
      );
    }
  }
);

//Getting gift URL link
export const giftPageLink = createAsyncThunk(
  "profile/giftPageLink",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Api.post("/gift_page_link", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to purchase gift" }
      );
    }
  }
);

//Getting gift details by id
export const getGiftById = createAsyncThunk(
  "profile/getGiftById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Api.get(`/gift_detail/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to get gift details" }
      );
    }
  }
);

//Sending Coordinates API call
export const sendCoordinates = createAsyncThunk(
  "profile/sendCoordinates",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Api.post("/add_codes", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to send coordinates" }
      );
    }
  }
);

//Getting All Users Gift
export const getGiftsList = createAsyncThunk(
  "profile/getGiftsList",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Api.get(`/all_send_codes/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to get gift details" }
      );
    }
  }
);
